import { ApolloError, gql } from "@apollo/client";

export const SEND_PROCESS_MESSAGE = gql`
    mutation SendProcessMessage($input: ProcessMessageInput!) {
        sendProcessMessage(input: $input) {
            requestId
        }
    }
`;
